// life-link.ai/src/components/LifeLinkAddOns.js
import React, { useState } from "react";

export default function LifeLinkAddOns() {
  const [addons, setAddons] = useState({
    cadSync: true,
    realtimeTranscription: false,
    autoTriage: true,
  });

  const toggle = (key) => setAddons((s) => ({ ...s, [key]: !s[key] }));

  const Row = ({ label, desc, on, onToggle }) => (
    <div
      style={{
        display: "flex",
        alignItems: "start",
        gap: 12,
        padding: "10px 12px",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        background: "#fff",
      }}
    >
      <div style={{ fontSize: 22 }}>{on ? "🟢" : "⚪️"}</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700 }}>{label}</div>
        <div style={{ color: "#6b7280", fontSize: 13 }}>{desc}</div>
      </div>
      <button
        onClick={onToggle}
        style={{
            padding: "6px 10px",
            borderRadius: 8,
            border: "1px solid #e5e7eb",
            background: on ? "#111827" : "#fff",
            color: on ? "#fff" : "#111827",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 12,
            minWidth: 90,
        }}
        aria-pressed={on}
      >
        {on ? "Enabled" : "Enable"}
      </button>
    </div>
  );

  return (
    <section
      aria-label="LifeLink Add-Ons"
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        background: "#f9fafb",
        padding: "12px",
      }}
    >
      <h3 style={{ margin: "0 0 8px 0" }}>LifeLink Add-Ons (Preview)</h3>
      <div style={{ display: "grid", gap: 8 }}>
        <Row
          label="CAD Sync"
          desc="Sync accepted/archived incidents to your CAD provider."
          on={addons.cadSync}
          onToggle={() => toggle("cadSync")}
        />
        <Row
          label="Real-time Transcription"
          desc="Show call transcripts alongside dispatcher actions."
          on={addons.realtimeTranscription}
          onToggle={() => toggle("realtimeTranscription")}
        />
        <Row
          label="Auto-Triage"
          desc="Let AI auto-archive low/moderate incidents during breathers."
          on={addons.autoTriage}
          onToggle={() => toggle("autoTriage")}
        />
      </div>
    </section>
  );
}
